import { Outlet, NavLink, Navigate } from "react-router-dom";
import { useCurrentUser } from "@/auth/RequireAuth";

const navItems = [
  { path: "/admin", label: "Dashboard", icon: "📊" },
  { path: "/admin/users", label: "Users", icon: "👤" },
  { path: "/admin/orgs", label: "Organizations", icon: "🏢" },
  { path: "/admin/billing", label: "Billing & Plans", icon: "💳" },
  { path: "/admin/platform-admins", label: "Platform Admins", icon: "🛡️" },
  { path: "/admin/policies", label: "Policies", icon: "⚖️" },
  { path: "/admin/audit", label: "Audit Log", icon: "📋" },
];

export function AdminLayout() {
  const user = useCurrentUser();

  // Gate: redirect non-admins
  if (!user?.is_platform_admin) {
    return <Navigate to="/workspace" replace />;
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <nav
        style={{
          width: 240,
          borderRight: "1px solid var(--border-color, #e0e0e0)",
          padding: "16px 0",
          display: "flex",
          flexDirection: "column",
          background: "var(--surface-bg, #fafafa)",
        }}
      >
        <div style={{ padding: "0 16px 16px", borderBottom: "1px solid var(--border-color, #e0e0e0)" }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Admin Console</h2>
          <a
            href="/workspace"
            style={{ fontSize: 12, color: "var(--text-secondary, #666)", textDecoration: "none" }}
          >
            ← Back to Chat
          </a>
        </div>

        <div style={{ padding: "8px 0", flex: 1 }}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/admin"}
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 16px",
                textDecoration: "none",
                color: isActive ? "var(--primary, #2563eb)" : "var(--text-primary, #333)",
                background: isActive ? "var(--primary-bg, #eff6ff)" : "transparent",
                fontWeight: isActive ? 500 : 400,
                fontSize: 14,
                borderRadius: 0,
              })}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>

        <div style={{ padding: "16px", borderTop: "1px solid var(--border-color, #e0e0e0)", fontSize: 11, color: "var(--text-secondary, #999)" }}>
          Platform Admin: {user?.email}
        </div>
      </nav>

      {/* Content */}
      <main style={{ flex: 1, padding: 24, overflow: "auto" }}>
        <Outlet />
      </main>
    </div>
  );
}
